import styled from 'styled-components';

export const PerksSection = styled.section`
`;

export const PerksHeading = styled.h2`
  display: inline-block;
  margin: 0;
  margin-bottom: 5px;
  padding: 10px;
  
  font-weight: 600;
  font-size: 14px;
  line-height: 1;
  
  border-radius: 20px 0 20px 0;
  
  ${({ passType }) => {
    switch (passType) {
      case 0:
        return `
          color: #783004;
          background-color: #fbd304;
        `;
      default:
        return `
          color: #783004;
          background-color: #fbd304;
        `
    }  
  }}
`;

export const PerksList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  
  li {
    width: 48%;
  }
  
  li:not(:last-child) {
    margin-bottom: 10px;
  }
  
  @media (min-width: 1024px) {
    flex-wrap: nowrap;
    flex-direction: column;
    
    li {
      width: auto;
    }
  }
`;

export const PerksTitle = styled.h3`
  margin: 0;
  margin-bottom: 10px;
  padding: 0;
  
  font-size: 12px;
  line-height: 1;
`;

export const PerksDescription = styled.p`
  margin: 0;
  padding: 0;
  
  font-size: 12px;
  line-height: 18px;
  
  @media (min-width: 768px) {
    font-size: 16px;
  }
`;
